import React, { useState } from "react";

const EditVisionMission = () => {
  const [sectionHeader, setSectionHeader] = useState("");
  const [vision, setVision] = useState([""]);
  const [mission, setMission] = useState([""]);

  const handleSectionHeaderChange = (e) => setSectionHeader(e.target.value);

  const handleVisionChange = (index, e) => {
    const newVision = [...vision];
    newVision[index] = e.target.value;
    setVision(newVision);
  };

  const handleMissionChange = (index, e) => {
    const newMission = [...mission];
    newMission[index] = e.target.value;
    setMission(newMission);
  };

  const handleAddVisionParagraph = () => setVision([...vision, ""]);
  const handleAddMissionParagraph = () => setMission([...mission, ""]);

  const handleSaveChanges = () => {
    const data = { sectionHeader, vision, mission };
    console.log("Saving changes:", data);
    // Replace with API call or other save logic
  };

  return (
    <div className="edit-about edit-vision-mission">
      <h2>Edit Vision & Mission Section</h2>

      {/* Section Header Input */}
      <div className="form-group">
        <label htmlFor="sectionHeader">Section Header</label>
        <input
          type="text"
          id="sectionHeader"
          value={sectionHeader}
          onChange={handleSectionHeaderChange}
          placeholder="Enter section header"
        />
      </div>

      {/* Vision Section */}
      <div className="form-group">
        <label>Vision</label>
        {vision.map((text, index) => (
          <div key={index} className="paragraph-group">
            <textarea
              value={text}
              onChange={(e) => handleVisionChange(index, e)}
              placeholder="Enter vision details"
            ></textarea>
            {index > 0 && (
              <button
                type="button"
                onClick={() => setVision(vision.filter((_, i) => i !== index))}
                className="remove-paragraph-btn"
              >
                Remove
              </button>
            )}
          </div>
        ))}
        <button type="button" onClick={handleAddVisionParagraph} className="add-paragraph-btn">
          Add More Vision Paragraph
        </button>
      </div>

      {/* Mission Section */}
      <div className="form-group">
        <label>Mission</label>
        {mission.map((text, index) => (
          <div key={index} className="paragraph-group">
            <textarea
              value={text}
              onChange={(e) => handleMissionChange(index, e)}
              placeholder="Enter mission details"
            ></textarea>
            {index > 0 && (
              <button
                type="button"
                onClick={() => setMission(mission.filter((_, i) => i !== index))}
                className="remove-paragraph-btn"
              >
                Remove
              </button>
            )}
          </div>
        ))}
        <button type="button" onClick={handleAddMissionParagraph} className="add-paragraph-btn">
          Add More Mission Paragraph
        </button>
      </div>

      {/* Save Changes Button */}
      <button type="button" onClick={handleSaveChanges} className="save-btn">
        Save Changes
      </button>
    </div>
  );
};

export default EditVisionMission;
